import { createSlice } from "@reduxjs/toolkit";
const userTypeSlice = createSlice({
    name: 'userTypeAction',
    initialState: {
        userTypeAction:'',
        currentBrand: {
            title: "",
            id: "",
            image: ""
        },
        userData: null,
        totalBrands: [],
        token: {
            access: "",
            refresh: ""
        },
        isApproved: undefined,
        personalInfoResponse: null,
        productCategory: []
    },
    reducers: {
        setUserTypeSlice : (state, action) => { state.userTypeAction = action.payload.userTypeActionUpdate},
        setCurrentBrand : (state, action) => { state.currentBrand = action.payload.currentBrand},
        setTotalBrands : (state, action) => { state.totalBrands = action.payload.totalBrands},
        setToken : (state, action) => { state.token = action.payload.token},
        setIsApproved : (state, action) => { state.isApproved = action.payload.isApproved},
        setUserData : (state, action) => { state.userData = action.payload.userData},
        setPersonalInfoResponse : (state, action) => { state.personalInfoResponse = action.payload.personalInfoResponse},
        setProductCategory : (state, action) => { state.productCategory = action.payload.productCategory},
    }
});
export const  addUserTypeAction  = userTypeSlice.actions.setUserTypeSlice;
export const  addCurrentBrand  = userTypeSlice.actions.setCurrentBrand;
export const  addTotalBrands  = userTypeSlice.actions.setTotalBrands;
export const  addToken  = userTypeSlice.actions.setToken;
export const  addIsApproved  = userTypeSlice.actions.setIsApproved;
export const  addUserData  = userTypeSlice.actions.setUserData;
export const  addPersonalInfoResponse  = userTypeSlice.actions.setPersonalInfoResponse;
export const  addProductCategory  = userTypeSlice.actions.setProductCategory;
export default userTypeSlice.reducer;